import MainLayout from "@/components/layout/MainLayout.vue";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";
import axios from "axios";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AttendanceStatus from '@/assets/json/attendanceStatus.json'

const convertNumberService = new ConvertNumService();

export default {
  name: "attendanceDetail",

  components: {
    MainLayout
  },

  data() {
    return {
      keyword: "",
      studentAttendance: {},
      sessionDate: [],
      totalStudents: '',
      attStatus: AttendanceStatus
    };
  },

  computed: {
    ...mapGetters(["teacherId", "studentId", "userType"]),
  },

  methods: {
    logout(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
    },

    getAttendanceDetail() {
      axios.get(`my/attendance/${this.$route.params.id}/rate`)
      .then((res) => {
        const total = res.data.attendance ? res.data.attendance.length : 0;
        this.totalStudents = convertNumberService.convertEng2Mm(total);
        this.studentAttendance = res.data.attendance
        this.sessionDate = res.data.sessions
      })
      .catch((err) => {
        if (err.response.status == 403) {
          this.$router.push({ name: 'forbidden'});
        }
        this.logout(err)
      })
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {month:'short',day:'numeric'})
    },

    search() {
      if (!this.keyword || this.keyword.trim() === "") {
        this.getAttendanceDetail()
        return
      }
      axios.get(`my/attendance/search`, { params: {
        keyword: this.keyword,
        class_id: this.$route.params.id
      } })
      .then((res) => {
        const total = res.data.attendance ? res.data.attendance.length : 0;
        this.totalStudents = convertNumberService.convertEng2Mm(total);
        this.studentAttendance = res.data.attendance
        this.sessionDate = res.data.sessions
      })
      .catch((err) => {
        this.logout(err)
      })
    },

    formatAttendanceRate(statusId) {
      const found = this.attStatus.find(s => s.id == statusId)
      return found ? found.point : '-'
    },

    getStatusColor(status) {
      const found = this.attStatus.find(s => s.id == status);
      return found ? found.color : 'att-none'
    }
  },

  mounted() {
    this.getAttendanceDetail()
    fetchNotificationCount();
  }
};
